import { configureStore, ThunkAction, Action, createListenerMiddleware } from "@reduxjs/toolkit";
import userAuth from "../features/userAuth/userAuth";
import distributoreCatalogue from "../features/distributoreCatalogue/distributoreCatalogue";
import leadUserCatalogue, { resetFilters } from "../features/leadUserCatalogue/leadUserCatalogue";
import leadUserCart from "../features/leadUserCart/leadUserCart";
import distributoreCart from "../features/distributoreCart/distributoreCart";

// Create the middleware instance
const listenerMiddleware = createListenerMiddleware();

// Add one-off listeners
listenerMiddleware.startListening({
  predicate: (action) => action.type === 'userAuth/logout/fulfilled',
  effect: (action, listenerApi) => {
    // Reset filters when user logs out
    listenerApi.dispatch(resetFilters());
  },
});

export const store = configureStore({
  reducer: {
    userAuth: userAuth,
    distributoreCatalogue: distributoreCatalogue,
    leadUserCatalogue: leadUserCatalogue,
    leadUserCart: leadUserCart,
    distributoreCart:distributoreCart,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['leadUserCatalogue/resetFilters'],
      },
    }).prepend(listenerMiddleware.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
